<template>
  <basic-selects
    :trigger="trigger"
    :isMultiple="isMultiple"
    :columns="columns"
    :items="selectableItems"
    title="選擇口味"
    idProperty="TasteId"
    nameProperty="TasteName"
    allSelectId="modifierTasteAllSelectBox"
    @onSaved="onSaved"
    :id="id"
    :pagination="pagination"
    @getItems="getItems"
    sortBy="TasteName"
    :defaultItems="defaultItems"
    viewName="ModifierTasteSelects"
  ></basic-selects>
</template>

<script>
import basicSelects from "./BasicSelects";

export default {
  data() {
    return {
      searchTypes: null,
      selectableItems: [],
      columns: [
        {
          name: "TasteName",
        },
      ],
      id: "tasteSelectModal",
      pagination: {},
    };
  },
  props: {
    trigger: false,
    isMultiple: false,
    currentId: undefined,
    modalId: undefined,
    defaultItems: undefined,
  },
  watch: {
    modalId: {
      handler(value) {
        if (value) this.id = value;
      },
      immediate: true,
    },
    trigger() {
      this.getItems();
    },
  },
  components: {
    basicSelects,
  },
  methods: {
    onSaved(items) {
      this.$emit("onSaved", items);
    },
    getItems() {
      if (!this.id) return;
      const vm = this;
      this.$api.onlineOrderModifierGroups
        .getSelectableTastes(vm.currentId)
        .then((data) => {
          vm.selectableItems = data;
        });
    },
  },
};
</script>
